import api from "../api";

export default {
    show() {
        return api.get('/central/account')
    },

    patch(data) {
        return api.patch('/central/account', data)
    },

    acceptLegal() {
        return api.patch('/central/account/acceptLegal')
    }
}